import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Input from './Input'

class HexInput extends Component {
  onChange = (value) => {
    const { onChange } = this.props
    const prefix = '0x'
    const valueLength = value.length

    if (valueLength === 2)
      value = ''
    else if (valueLength === 1)
      value = prefix + value
    else if (valueLength > 6)
      value = value.slice(0, 6)

    if(onChange) onChange(value)
  }

  isValid() {
    let { value } = this.props
    let errorText = 'Invalid Hex'
    const noPrefix = value.slice(2)
    const isMatch = noPrefix.match(/^[a-fA-F0-9]*$/)

    if (isMatch)
      errorText = ''

    return errorText
  }

  render() {
    const {
      value,
      hint,
      error
    } = this.props
    const errorMsg = error
      ? error
      : this.isValid()

    return (
      <Input
        hint={hint}
        value={value}
        error={errorMsg}
        onChange={this.onChange}
      />
    )
  }
}

export default HexInput
